/**
 * useFontLoader - CookieRun 폰트 CDN 로딩 훅
 *
 * 레거시 깨구단2와 동일한 CookieRun 폰트 3종을 로드.
 * 한 번만 로드하고 이후 캐싱됨.
 */
import { useEffect, useState } from 'react'
import { FONT_CDN_BASE, FONTS } from '../constants'

let fontsLoaded = false
let fontsPromise: Promise<void> | null = null

function loadFonts(): Promise<void> {
  if (fontsLoaded) return Promise.resolve()
  if (fontsPromise) return fontsPromise

  fontsPromise = (async () => {
    const fontConfigs = [
      { family: FONTS.regular, file: 'CookieRun_Regular.ttf' },
      { family: FONTS.bold, file: 'CookieRun_Bold.ttf' },
      { family: FONTS.black, file: 'CookieRun_Black.ttf' },
    ]

    const promises = fontConfigs.map(async ({ family, file }) => {
      const font = new FontFace(family, `url("${FONT_CDN_BASE}/${file}")`)
      const loaded = await font.load()
      document.fonts.add(loaded)
    })

    await Promise.all(promises)
    fontsLoaded = true
  })()

  return fontsPromise
}

export function useFontLoader() {
  const [ready, setReady] = useState(fontsLoaded)

  useEffect(() => {
    if (fontsLoaded) {
      setReady(true)
      return
    }
    loadFonts().then(() => setReady(true))
  }, [])

  return ready
}
